module.exports = __webpack_public_path__ + "img/jf.5ab39dce.png";